import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Pricing.module.css';
import { CheckSmall } from '../../icons';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const Header = () => (
  <header className={styles.hero}>
    <div className={`${styles.container} ${styles.heroGrid}`}>
      <div>
        <div className={`${styles.breadcrumb} ${styles.reveal} ${styles.d1}`}>
          <Link to="/">Fyntiq Business</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCur}>Pricing</span>
        </div>
        <h1 className={`${styles.reveal} ${styles.d2}`}>
          Simple pricing.<br /><span className={styles.hl}>Pay when you get paid.</span>
        </h1>
        <p className={`${styles.heroSub} ${styles.reveal} ${styles.d3}`}>
          Free to get started with invoicing, accounting, and expense tracking. Pay standard per-transaction fees only when money moves — no setup fees, no surprises.
        </p>
        <div className={`${styles.heroCta} ${styles.reveal} ${styles.d4}`}>
          <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Get started free</Link>
          <a href="#fees" className={styles.btnOutlineHero}>See processing fees</a>
        </div>
        <div className={`${styles.heroNote} ${styles.reveal} ${styles.d5}`}>
          <span><CheckSmall />Free core features</span>
          <span><CheckSmall />No monthly minimum</span>
          <span><CheckSmall />Upgrade anytime</span>
        </div>
      </div>

      <div className={`${styles.heroVisual} ${styles.reveal} ${styles.d3}`}>
        <div className={`${styles.floatChip} ${styles.fcCash}`}>
          <div className={`${styles.fcIc} ${styles.fcIcY}`}>
            <span className={styles.mono} style={{ fontSize: 14, fontWeight: 700 }}>$0</span>
          </div>
          <div><div className={styles.fcLab}>Starter</div><div className={styles.fcVal}>Free</div></div>
        </div>
        <div className={`${styles.floatChip} ${styles.fcPayout}`}>
          <div className={`${styles.fcIc} ${styles.fcIcG}`}><CheckSmall /></div>
          <div><div className={styles.fcLab}>Invoicing</div><div className={styles.fcVal}>Included</div></div>
        </div>

        <div className={styles.payCard}>
          <div className={styles.invTop}>
            <div><div className={styles.invLab}>MONTHLY</div><div className={styles.invNum}>Starter plan</div></div>
            <span className={styles.invStatus} style={{ background: 'var(--green-soft)', color: 'var(--green)' }}>Free</span>
          </div>
          <div className={styles.invRow}><span>Invoicing &amp; accounting</span><span className={styles.mono}>Included</span></div>
          <div className={styles.invRow}><span>Payment processing</span><span className={styles.mono}>Per transaction</span></div>
          <div className={styles.invRow}><span>Setup fee</span><span className={styles.mono}>$0</span></div>
          <div className={styles.invTotal}><span>Monthly cost</span><span className={styles.mono}>$0</span></div>
          <Link to={`${dashboardUrl}/signup`} className={styles.invPaynow} style={{ display: 'block' }}>Start free →</Link>
        </div>
      </div>
    </div>
  </header>
);

export default Header;
